module["exports"] = [
  "gmail.com",
  "yahoo.fr",
  "hotmail.fr"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/internet/free_email.js
// module id = 1196
// module chunks = 0